import { EnumUploadCargaTipo } from "model/enums/enum-upload-carga-tipo";

export class UploadCargaCadastroFormModel {
  constructor(
    public conversao: string = "",
    public tipo: EnumUploadCargaTipo = EnumUploadCargaTipo.PRODUTO
  ) { }
}
